// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MedicalGasRequestDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class MedicalGasRequestApiClient extends BaseCRUDApiClient<MedicalGasRequestDto> {
  baseUrl = this.config.apiEndpoint + '/medical-gas-request';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
